export default {
	change_password: "Change Password",
	control_pannel: "Control Panel",
	idiom: "language",
	messages: "Messages",
	my_profile: "My profile",
	no_notification_available: "No notification available",
	no_notifications_avaliable: "No notifications available",
	sign_out: "Sign out"
}